<template>
  <div v-if="oneMarket" class="item-odds">
    <v-card class="d-flex align-center" dense flat tile height="45">
      <v-btn
        text
        tile
        color="white"
        class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <span class="black--text manage-ellipsis">
          {{ runner.name }}
          <div v-if="$auth.loggedIn">
            <span
              v-if="books && oneMarket && books[`${oneMarket.id}`]"
              :class="{
                'green--text ': getBooks(books, runner.id) > 0,
                'red--text': getBooks(books, runner.id) < 0,
                'black--text ': getBooks(books, runner.id) == 0
              }"
            >
              {{
                (getBooks(books, runner.id) / getMyRate()) | currencyFormat(2)
              }}
            </span>
          </div>
        </span>
      </v-btn>
      <v-spacer></v-spacer>
      <ladder-btn
        v-if="books && oneMarket && books[`${oneMarket.id}`]"
        :session-id="books && oneMarket && books[`${oneMarket.id}`]"
        :session-name="oneMarket && oneMarket.name"
      ></ladder-btn>
      <!-- v-if="
        fancyRunner.status !== 'resultDeclared' &&
        checkIfSuspended(fancyRunner, 'fancy')
      " -->
      <odds-disabled
        v-if="
          (oneMarket && oneMarket.isBettable === false) ||
          (oneMarket && oneMarket.statusLabel === 'Ball Running')
        "
        :text="checkIfSuspended(oneMarket, 'fancy')"
        :issideright="'rightsidebutton'"
        class="fancy-odds"
        v-bind="$attrs"
        v-on="$listeners"
      ></odds-disabled>
      <!-- <odds-disabled
        v-if="market.isBettable === false || market.statusLabel"
        :issideright="'rightsidebutton'"
        class="fancy-odds"
        v-bind="$attrs"
        v-on="$listeners"
      >
        Result: {{ fancyRunner.resultLogs[0].result | currencyFormat(0) }}
      </odds-disabled> -->

      <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly, 'lay')">
        <btn-odds
          :key="'lay' + key"
          type="lay"
          :class="{ 'opacity-0': i !== 0 }"
          @betData="
            $store.commit('placeBet/openPopover', {
              event: oneMarket,
              market: market[i],
              runner,
              allRunners: market[i].runners,
              oddsIndex: i,
              odds: {
                price: getObjValue(runner.lay, i, ['line'], '-'),
                fancyPrice: getObjValue(runner.lay, i, ['price'], '-'),
                index: i,
                type: 'lay'
              },
              bettingType: 'bookmaker'
            })
          "
        >
          <span
            v-if="runner && runner.lay[i] && runner.lay[i].line"
            class="d-block text-center"
          >
            {{ runner.lay[i].line }}
          </span>
          <span v-else class="d-block text-center">-</span>
          <span
            v-if="runner && runner.lay[i] && runner.lay[i].price"
            class="d-block text-center mini-rate"
          >
            {{ runner.lay[i].price }}
          </span>
        </btn-odds>
      </template>
      <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly, 'back')">
        <btn-odds
          :key="'back' + key"
          type="back"
          :class="{ 'opacity-0': i !== 0 }"
          @betData="
            $store.commit('placeBet/openPopover', {
              event: oneMarket,
              market: market[i],
              runner,
              allRunners: null,
              oddsIndex: i,
              odds: {
                price: getObjValue(runner.back, i, ['line'], '-'),
                fancyPrice: getObjValue(runner.back, i, ['price'], '-'),
                index: i,
                type: 'back'
              },
              bettingType: 'bookmaker'
            })
          "
        >
          <span
            v-if="runner && runner.back[i] && runner.back[i].line"
            class="d-block text-center"
          >
            {{ runner.back[i].line }}
          </span>
          <span v-else class="d-block text-center">-</span>
          <span
            v-if="runner && runner.back[i] && runner.back[i].price"
            class="d-block text-center mini-rate"
          >
            {{ runner.back[i].price }}
          </span>
        </btn-odds>
      </template>
    </v-card>
    <bet-popover
      v-if="
        $breakpoint.smAndDown &&
        oneMarket &&
        betslipOpener($auth, $store, runner.id, oneMarket.id, oneMarket)
      "
      :check-id="runner.id"
    ></bet-popover>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import cloneDeep from 'lodash/cloneDeep'
import OddsDisabled from '@/components/OddsDisabled'
import BtnOdds from '@/components/BtnOdds'
import LadderBtn from '@/components/LadderBtn'
import BetPopover from '@/components/BetPopover'
// import socket from '~/plugins/socket.client'

export default {
  name: 'FancyInnerOdds',
  components: {
    BtnOdds,
    OddsDisabled,
    LadderBtn,
    BetPopover
  },
  props: {
    market: { type: [Object, Array], default: () => [], required: false },
    runner: { type: Object, default: () => {}, required: true },
    marketId: { type: [String, Number], default: 0, required: false },
    bookmaker: { type: Boolean, default: false },
    oneMarket: { type: Object, default: () => {}, required: false }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      books: (state) => state.betBooks.data
    })
  },
  created() {
    // this.runner = this.runners
    // this.fancyRunner = cloneDeep(this.runner)
    // socket.on('market_' + this.fancyRunner.betfairId, (data) => {
    //   this.fancyRunner = data
    // })
    // console.log('binnary', this.books)
  },
  beforeDestroy() {
    // socket.off('market_' + this.fancyRunner.betfairId)
  },
  methods: {
    getBooks(books, id) {
      // console.log('booksFancy', books, id, this.oneMarket)
      if (
        books &&
        this.oneMarket &&
        Object.keys(books).filter((item) => item.includes(this.oneMarket.id))
      ) {
        return (
          books[`${this.oneMarket.id}`] && books[`${this.oneMarket.id}`].pnl
        )
      }
    },
    getObjValue(object, i, j, output) {
      if (object.length === 1) {
        return object && object.length && object?.[0]?.[j]
          ? object[0][j]
          : output
      } else {
        return object && object.length && object?.[i]?.[j]
          ? object[i][j]
          : output
      }
    },
    check(runner, key, i, market) {
      let result = false
      if (market) {
        i = 2 - i
        result =
          runner &&
          runner?.[key] &&
          runner?.[key]?.length > 0 &&
          runner?.[key][0] &&
          runner?.[key][0].length > 0 &&
          runner?.[key][0][i]
      } else {
        result =
          runner &&
          runner?.[key] &&
          runner?.[key]?.length > 0 &&
          runner?.[key][i] &&
          runner?.[key][i].length > 0 &&
          runner?.[key][i][1]
      }
      return result
    },
    xsOnlyOdds(bool, type) {
      if (bool) {
        return [0]
      } else {
        if (type === 'lay') {
          return [0]
        }
        return [0, 1, 2]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.opacity-0 {
  opacity: 0;
}

@media (max-width: 768px) {
  .manage-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
  }
}
</style>
